import script from "./hearderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./hearderPage.vue?vue&type=script&setup=true&lang=js"

import "./hearderPage.vue?vue&type=style&index=0&id=42898634&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\乐伴伴10.9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42898634"]])

export default __exports__